export class Asset {
    public _id: string;
    public label: string;
    public type: string;

    constructor() { }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/asset.ts